import React, { useState, useEffect, useRef } from 'react';
import Input from '../Input';
import Dropdown from '../Dropdown';
import closeIcon from '../../Assets/Icons/close.png';
import { postData } from "../../ApiServices/ApiService";
import { ORG_ADD_TEMPLATE } from "../../ApiServices/BaseURL";
import Loader from "../../Components/Loader";
import { logFrontendException } from "../../Utils/Exception";
import { useTheme } from "../../GlobalContext/GlobalContext";
import error from '../../Assets/Icons/error_message.png';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
// import 'react-quill/dist/quill.bubble.css';

const ConfigurationAddTemplateModal = ({ isOpen, onClose, channelType, refreshHandlers }) => {
  const [templateName, setTemplateName] = useState('');
  const [channel, setChannel] = useState(null);
  const [templateText, setTemplateText] = useState('');
  const [templateID, setTemplateID] = useState('');
  const [templateNameError, setTemplateNameError] = useState('');
  const [channelNameError, setChannelNameError] = useState('');
  const [templateIDError, setTemplateIDError] = useState('');
  const [templateTextError, setTemplateTextError] = useState('');
  const [templateAddLoading, setTemplateAddLoading] = useState(false);
  const [templateAddSuccess, setTemplateAddSuccess] = useState("");
  const [templateAddError, setTemplateAddError] = useState("");

  const pageName = 'ConfigurationAddTemplateModal';
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
  const { setIsLoginPopup } = useTheme();

  useEffect(() => {
    console.log('channelType useeffect', channelType)
    const selectedOption = channelOptions.find(
      (option) => option.value === channelType.toLowerCase()
    );
    if (selectedOption) {
      setChannel(selectedOption);
    }
  }, [channelType])

  // Reset form fields to initial values
  const resetForm = () => {
    clearFeilds();
    setTemplateAddSuccess('');
  };

  // Run resetForm when modal closes
  useEffect(() => {
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const whatsAppStatus = JSON.parse(localStorage.getItem('whatsAppStatus'));
  const channelOptions = [
    whatsAppStatus === 1 ? { label: "WhatsApp", value: 'whatsapp' } : null,
    { label: "Email", value: 'email' },
    { label: "SMS", value: 'sms' }
  ].filter(Boolean);
  const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const dropdownRefs = useRef({}); // Ref for dropdown

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = Object.keys(dropdownRefs.current).every(
        (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
      );
      if (isOutside) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!isOpen) return null;

  const validateFields = () => {
    console.log('validateFields')
    let hasError = false;

    if (channel?.value === null || channel?.value === undefined) {
      setChannelNameError("Channel selection is required.");
      hasError = true;
    }

    if (isEmpty(templateName)) {
      setTemplateNameError("Template name is required.");
      hasError = true;
    }
    if (templateName.trim().length > 100) {
      setTemplateNameError("Template name need to be within length of 100.");
      hasError = true;
    }
    if (channel && channel?.value === 'sms' && isEmpty(templateID)) {
      setTemplateIDError("Template id is required.");
      hasError = true;
    }
    if (templateID.trim().length > 20) {
      setTemplateIDError("Template id need to be within length of 20.");
      hasError = true;
    }
    if (isQuillContentEmpty(templateText)) {
      setTemplateTextError("Message content is required.");
      hasError = true;
    }

    return !hasError;
  };

  const handleAddTemplate = async () => {
    try {
      if (!validateFields()) return;
      console.log('handleAddTemplate')
      setTemplateAddLoading(true);
      setTemplateAddSuccess("");
      setTemplateAddError("");
      const storedUserInfo = JSON.parse(localStorage.getItem("_userInfo_"));
      const payload = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "channel_name": channel?.value || 0,
        "template_name": templateName || '',
        "template_text": templateText || '',
        "template_id": templateID || ''

      };
      console.log('payload ', payload);
      const response = await postData(ORG_ADD_TEMPLATE, payload);
      const responseData = await response.json();
      if (response.status === 200) {
        if (responseData.status_code === 200) {
          if (responseData.message.toLowerCase() === "success") {
            setTemplateAddSuccess(responseData.info || "Template added successfully.");
            clearFeilds();
            setTimeout(() => {
              onClose();
              const selectedChannel = channel?.value;
              if (selectedChannel && refreshHandlers[selectedChannel]) {
                refreshHandlers[selectedChannel]();
              }
            }, 2000);
          } else {
            setTemplateAddError(responseData.info || "Failed to add template.");
            logFrontendException(storedUserId, pageName, 'handleAddTemplate', responseData?.info || '');
          }
        } else {
          setTemplateAddError(responseData.info || "Failed to add template. Please try again.");
          logFrontendException(storedUserId, pageName, 'handleAddTemplate', responseData || '');
        }
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setTemplateAddError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        logFrontendException(storedUserId, pageName, 'handleAddTemplate-Unauthorized', response || '');
      } else {
        setTemplateAddError(responseData.info || "Server error. Please try again later.");
        logFrontendException(storedUserId, pageName, 'handleAddTemplate', response || '');
      }
    } catch (err) {
      setTemplateAddError("Failed to add template. Please check your network connection and try again.");
      // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/templateAddError)
      logFrontendException(storedUserId, pageName, 'handleAddTemplate-catch', err || '');
    } finally {
      setTemplateAddLoading(false);
    }
  };

  const clearFeilds = () => {
    setChannel(null);
    setTemplateName('');
    setTemplateText('');
    setTemplateID('');
    setChannelNameError('');
    setTemplateNameError('');
    setTemplateIDError('');
    setTemplateTextError('');
    setTemplateAddError('');
  }

  const handleDropdownChange = (value) => {
    setChannel(value);
    setChannelNameError('');
    setTemplateNameError('');
    setTemplateIDError('');
    setTemplateTextError('');
  }

  const handleTemplateNameChange = (value) => {
    setTemplateName(value);
    if (value.trim().length > 0) {
      setTemplateNameError('');
    }
  };

  const handleTemplateIDChange = (value) => {
    setTemplateID(value);
    if (value.trim().length > 0) {
      setTemplateIDError('');
    }
  };

  const handleQuillTextChange = (value) => {
    setTemplateText(value);
    const plainText = value.replace(/<[^>]+>/g, '').trim();
    if (plainText.length > 0) {
      setTemplateTextError('');
    }
  };

  const isEmpty = (str) => !str || str.trim().length === 0;
  const isQuillContentEmpty = (html) => !html || html.replace(/<[^>]+>/g, '').trim().length === 0;


  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="Close" style={styles.iconImage} />
        </button>
        <h2 className="modal-title">Add Template</h2>
        <hr className="title-divider" />
        <div className="form-grid">
          <Dropdown
            ref={(el) => (dropdownRefs.current["channel"] = el)}
            isOpen={openDropdown === "channel"}
            toggleDropdown={() => toggleDropdown("channel")}
            label="Channel"
            options={channelOptions}
            value={channel}
            onChange={(val) => { handleDropdownChange(val); }}
            errorMessage={channelNameError}
          />
          <Input
            label="Template Name"
            placeholder="Template Name"
            value={templateName}
            onChange={(e) => { handleTemplateNameChange(e.target.value); }}
            errorMessage={templateNameError}
            maxLength={100}
          />
          {channel && channel?.value === 'sms' && <Input
            label="Template ID"
            placeholder="Template ID"
            value={templateID}
            onChange={(e) => { handleTemplateIDChange(e.target.value); }}
            errorMessage={templateIDError}
            maxLength={20}
          />}
        </div>
        <div style={{ width: "100%", display: "flex", marginTop: '15px' }}>
          <div style={{ width: "100%" }}>
            <label style={{ ...styles.labaleStyle, display: "block" }}>
              Message Content
            </label>
            <div className={`${templateTextError ? 'quill-error' : 'quill-wrapper'}`}>
              <ReactQuill
                className="no-border-editor"
                // className="bubble-editor"
                theme="snow"
                value={templateText}
                onChange={handleQuillTextChange}
                style={{ minHeight: 200, maxHeight: 250, overflowY: 'auto' }}
              />
            </div>

            {templateTextError && (
              <div style={styles.errorMessage}>
                <span><img
                  src={error}
                  alt="Error"
                  style={{ width: "12px", height: "12px" }}
                /></span> {templateTextError}
              </div>
            )}
            {/* <textarea
              placeholder="Message Content"
              value={templateText}
              onChange={(e) => setTemplateText(e.target.value)}
              style={{ ...styles.textarea, width: "100%" }}
              rows={15}
            /> */}
          </div>
        </div>


        <hr className="footer-divider" />

        <div className="button-container">
          <button className="add-client-button" onClick={handleAddTemplate} style={{ paddingLeft: 30, paddingRight: 30, opacity: templateAddLoading ? 0.5 : 1, cursor: templateAddLoading ? 'not-allowed' : 'pointer' }} disabled={templateAddLoading}>
            <span style={{ paddingRight: templateAddLoading ? 10 : 0 }}><Loader loading={templateAddLoading} color={'#FFFFFF'} size='small' /></span>Add</button>
          <button className="cancel-button" onClick={() => { resetForm(); onClose(); }}>Cancel</button>
          {templateAddError && <div className="list-error-msg" style={{ marginBottom: '1px' }}>{templateAddError}</div>}
          {templateAddSuccess && <div className="list-success-msg" style={{ marginBottom: '1px' }}>{templateAddSuccess} </div>}
        </div>
      </div>
    </div >
  );
};

const styles = {
  iconImage: {
    width: '11px',
    height: '11px',
  },
  labaleStyle: {
    fontSize: '12px',
    marginBottom: '5px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    color: 'rgb(52, 60, 68)'
  },
  textarea: {
    border: "1px solid #d1e3ed",
    borderRadius: "5px",
    fontSize: "14px",
    padding: "10px",
    width: "100%",
    resize: "none", // Prevents resizing for consistent appearance
  },
  errorMessage: {
    color: "#EE201C",
    fontSize: "11px",
    marginTop: "4px",
    display: "flex",
    gap: "4px",
    fontWeight: '400'
  },
}

export default ConfigurationAddTemplateModal;